

























































import { Vue, Component, Prop } from 'vue-property-decorator'

type Page = {
  index: number
  content: number
  isSelected: boolean
  disabled: boolean
}

type BreakView = {
  breakView: boolean
}

type Pages = {
  [index: number]: Page | BreakView
}

const computeRange = (
  selected: number,
  pageRange: number,
  pageCount: number
): number[] => {
  const half = Math.floor(pageRange / 2)
  const low = Math.max(0, selected - 1 - half)
  const high = Math.min(pageCount - 1, low + pageRange - 1)

  return [Math.max(low, high - pageRange + 1), high]
}

const getPageItem = (
  selected: number,
  index: number,
  disabled: boolean
): Page => ({
  index: index,
  content: index + 1,
  isSelected: index === selected - 1,
  disabled
})

const getBreakView = (): BreakView => ({
  breakView: true
})

@Component
export default class Paginate extends Vue {
  @Prop(String) readonly pathName!: string
  @Prop({ default: 1 }) readonly selected!: number
  @Prop({ default: 'page' }) readonly pageParamKey?: string
  @Prop({ default: () => ({}) }) readonly urlParams!: object
  @Prop({ default: () => ({}) }) readonly queryParams!: object

  @Prop(Number) readonly totalCount!: number
  @Prop({ default: 20 }) readonly countPerPage!: number
  @Prop({ default: 5 }) readonly pageRange!: number
  @Prop({ default: false }) readonly disabled!: boolean

  get pageCount() {
    return Math.ceil(this.totalCount / this.countPerPage)
  }

  get pages(): Pages {
    const items: Pages = {}
    const disabled = this.disabled

    if (this.pageCount <= this.pageRange) {
      for (let index = 0; index < this.pageCount; index++) {
        items[index] = getPageItem(this.selected, index, disabled)
      }

      return items
    }

    const [low, high] = computeRange(
      this.selected,
      this.pageRange,
      this.pageCount
    )

    for (let i = low; i <= high && i <= this.pageCount - 1; i++) {
      items[i] = getPageItem(this.selected, i, disabled)
    }

    // `...`の部分
    if (low > 1) {
      const index = low - 1
      items[index] = getBreakView()
    }

    if (high + 1 < this.pageCount - 1) {
      const index = high + 1
      items[index] = getBreakView()
    }

    // 最初と最後のページ
    for (let i = 0; i < 1; i++) {
      items[i] = getPageItem(this.selected, i, disabled)
    }

    for (let i = this.pageCount - 1; i >= this.pageCount - 1; i--) {
      items[i] = getPageItem(this.selected, i, disabled)
    }

    return items
  }
}
